import { Dispatch } from 'react-redux';
import * as types from "./action-types";
import { AuthActionCreators, IApplicationState } from '../../index';
import {
    IEmailTemplateListResponse, IEmailTemplateResponse,
    IEmailSendeeListResponse, IEmailSendeeResponse, IEmailTemplate,
    IEmailTemplatePreview, IEmailTemplatePreviewResponse,
    IBaseResponse,
    IContactEntityType,
    IEmailAddressField
} from "../../../models/index";
import { IPost } from '../../authorization/index';
import { Utility } from '../../../services/utility';
import { IEmailTag } from '@nkr/models/email-engine/email-tag';

export interface IAddEmailTagResponse {
    data: {
        success: boolean,
        message: string,
        results: IEmailTag
    }
}

export interface IDeleteEmailTagResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            emailTemplateId: number,
            emailId: number
        }
    }
}

export interface IDeleteSendeeResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            emailTemplateId: number,
            emailSendeeId: number
        }
    }
}

export const ActionCreators = {
    getEmailTemplate: (emailTemplateId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IEmailTemplateResponse> => {
        var options = {
            url: __API__ + "/email-template/" + emailTemplateId,
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IEmailTemplateResponse) => {
            return Promise.resolve(response);
        });
    },
    getEmailTemplates: (emailFamilyId: number, emailTypeId: number, emailExcelId: number, emailModelId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IEmailTemplateListResponse> => {
        var options = {
            url: __API__ + "/email-template",
            data: {
                emailFamilyId: emailFamilyId,
                emailTypeId: emailTypeId,
                emailExcelId: emailExcelId,
                emailModelId: emailModelId
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IEmailTemplateListResponse) => {
            if (response.data.success) {
                dispatch(ActionCreators.setEmailTemplates(response.data.results));
            }

            return Promise.resolve(response);
        });
    },
    getPreview: (emailTemplateId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IEmailTemplatePreviewResponse> => {
        var options = {
            url: __API__ + "/email-template/" + emailTemplateId + "/preview"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IEmailTemplatePreviewResponse) => {
            if (response.data.success) {
                dispatch(ActionCreators.setPreview(response.data.results));
            }

            return Promise.resolve(response);
        });
    },
    sendPreview: (emailTemplateId: number, emailAddress: string, entityTypeId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + "/email-template/" + emailTemplateId + "/send-preview",
            data: {
                emailAddress,
                entityTypeId
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    getSendeeList: () => (dispatch: Dispatch<IApplicationState>): Promise<IEmailSendeeListResponse> => {
        var options = {
            url: __API__ + "/email-template/sendee-list",
        }

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IEmailSendeeListResponse) => {
            let { success, results } = response.data;

            if (success)
                dispatch(ActionCreators.setSendeeLists(results.emailAddressFields, results.contactEntityTypes));

            return Promise.resolve(response);
        });
    },
    addEmailTag: (emailTemplateId: number, emailFamilyId: number, emailTypeId: number, emailExcelId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IAddEmailTagResponse> => {
        var options = {
            url: __API__ + "/email-template/add-email-tag",
            data: {
                emailTemplateId,
                emailFamilyId,
                emailTypeId,
                emailExcelId
            }
        }

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IAddEmailTagResponse) => {
            return Promise.resolve(response);
        });
    },
    deleteEmailTag: (emailId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IDeleteEmailTagResponse> => {
        var options = {
            url: __API__ + "/email-template/delete-email-tag/" + emailId
        }

        return dispatch(AuthActionCreators.apiDelete(options)).then((response: IDeleteEmailTagResponse) => {
            return Promise.resolve(response);
        });
    },
    addSendee: (emailTemplateId: number, emailAddressFieldId: number, centerTypeId: number, contactEntityTypeId: number, contactPositionId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IEmailSendeeResponse> => {
        var options = {
            url: __API__ + "/email-template/add-sendee",
            data: {
                emailTemplateId,
                emailAddressFieldId,
                centerTypeId,
                contactEntityTypeId,
                contactPositionId
            }
        }

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IEmailSendeeResponse) => {
            return Promise.resolve(response);
        });
    },
    deleteSendee: (emailSendeeId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IDeleteSendeeResponse> => {
        var options = {
            url: __API__ + "/email-template/delete-sendee/" + emailSendeeId
        }

        return dispatch(AuthActionCreators.apiDelete(options)).then((response: IDeleteSendeeResponse) => {
            return Promise.resolve(response);
        });
    },
    saveEmailTemplate: (emailTemplateId: number, emailModelId: number, subject: string, body: string, sendToEntity: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<IEmailTemplateResponse> => {
        var options = {
            url: __API__ + "/email-template/save",
            data: {
                emailTemplateId,
                emailModelId,
                subject,
                body,
                sendToEntity
            }
        }

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IEmailTemplateResponse) => {
            return Promise.resolve(response);
        });
    },
    setPreview: (emailTemplatePreview: IEmailTemplatePreview) => {
        return {
            type: types.SET_PREVIEWDATA,
            emailTemplatePreview
        }
    },
    setEmailTemplates: (list: IEmailTemplate[]) => {
        return {
            type: types.SET_EMAILTEMPLATES,
            list
        }
    },
    setSendeeLists: (emailAddressFields: IEmailAddressField[], contactEntityTypes: IContactEntityType[]) => {
        return {
            type: types.SET_SENDEELISTS,
            emailAddressFields,
            contactEntityTypes
        }
    },
    setSaveEmailTemplate: (emailTemplate: IEmailTemplate) => {
        return {
            type: types.SET_SAVEEMAILTEMPLATE,
            emailTemplate
        }
    },
    deleteEmailTemplate: (id: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + "/email-template/" + id
        }

        return dispatch(AuthActionCreators.apiDelete(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        })
    }
}